export default "__VITE_ASSET__917ef612__"